import React from 'react';
export const IconRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 12.047L12 23L9.74844 20.7581L18.4969 12.047L9.74849 3.33595L12 1.09406L23 12.047Z"
      fill="#C4964D"
    />
    <rect
      width="6.35459"
      height="6.35459"
      transform="matrix(0.70862 -0.70559 -0.70862 -0.70559 9.49121 16.5311)"
      fill="#C4964D"
    />
  </svg>
);
